import React from 'react';
import NavigationSidebar from '../Navigation';
import NavigationSidebarItem from '../Navigation/NavigationSidebarItem';
import getAvailableRoutes, { ROUTE_USER_SETTINGS } from './getAvailableRoutes';
import { Logo } from 'settings';
import { Link } from 'react-router-dom';
import __, { __route } from 'localisation';
import './BackofficeSidebar.scss';
import { useMemo } from 'react';

interface BackofficeSidebarProps {
  name?: string;
  userRoles?: string[];
  contact_type?: string;
}

const BackofficeSidebar = (props: BackofficeSidebarProps) => {
  const routes = getAvailableRoutes(props.userRoles);

  // Filter out the user settings route that will be placed in the footer
  const filteredRoutes = routes.filter((route) => route.id !== ROUTE_USER_SETTINGS.id);

  // Get the initials of the user's name
  const initials = useMemo(() => {
    if (!props.name || typeof props.name !== 'string') {
      return '??'; // Default fallback initials
    }
    const initialsArray = props.name.split(' ').map((name) => name[0]);
    return initialsArray[0] + (initialsArray[initialsArray.length - 1] || '');
  }, [props.name]);

  const header = (
    <div className="backoffice-sidebar__navigation--header">
      <Link to="/" className="backoffice-sidebar__navigation--logo">
        <Logo inverted={false} />
      </Link>
    </div>
  );

  const footer = (
    <div className="backoffice-sidebar__navigation--footer">
      <div className="backoffice-sidebar__navigation--footer-content">
        <div className="backoffice-sidebar__navigation--footer-content-items">
          <NavigationSidebarItem label={ROUTE_USER_SETTINGS.title} to={ROUTE_USER_SETTINGS.route} icon="Cog" />
          <NavigationSidebarItem label={__('logout')} to={__route('logout')} icon="logout" />
        </div>
        <p className="backoffice-sidebar__navigation--footer-content-initials">{initials}</p>
      </div>
    </div>
  );

  return (
    <div className="backoffice-sidebar">
      <NavigationSidebar items={filteredRoutes} className="backoffice-sidebar__navigation" header={header} footer={footer} hideSubItemIcons />
    </div>
  );
};

export default BackofficeSidebar;
